/**
 * 微应用静态路由配置
 * 用于配置不需要在菜单中显示,但需要直接访问的微应用路由
 */
import Layout from '@/views/Layout';

export const microAppStaticRoutes = [
  {
    path: '/operation/questionnaireManage/questionnaireList/questionnaireDetail',
    name: 'QuestionnaireDetail',
    component: Layout,
    meta: {
      title: '问卷详情',
      moduleName: 'operation',
      roleId: null,
      isTabs: false,
      isSide: false,
    },
  },
  {
    path: '/operation/activityRegistration/userRegistrationManagement',
    name: 'userRegistrationManagement',
    component: Layout,
    meta: {
      title: '用户报名管理',
      moduleName: 'operation',
      roleId: null,
      isTabs: false,
      isSide: false,
    },
  },
];

/**
 * 获取指定微应用的静态路由
 * @param {string} moduleName - 微应用名称
 * @returns {Array} 静态路由数组
 */
export const getStaticRoutesByModule = (moduleName) => {
  return microAppStaticRoutes.filter(route => route.meta.moduleName === moduleName);
};
